type TagItAnonymousIdentity = {
  userId: string;
  entityId: string;
  entityidType?: 'ls' | 'ck';
  entityidAlgo?: 'native';
  entityidOwner?: string;
  sessionId?: string;
};

function readCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined;

  const prefix = `${encodeURIComponent(name)}=`;
  const match = document.cookie.split(';').map((part) => part.trim()).find((part) => part.startsWith(prefix));
  if (!match) return undefined;

  try {
    return decodeURIComponent(match.slice(prefix.length));
  } catch {
    return match.slice(prefix.length);
  }
}

function readLocalStorageTagItId(): string | undefined {
  if (typeof window === 'undefined') return undefined;

  try {
    const raw = window.localStorage.getItem('tagitId');
    if (!raw) return undefined;

    const parsed = JSON.parse(raw) as { entityId?: unknown };
    return typeof parsed.entityId === 'string' && parsed.entityId.trim() ? parsed.entityId.trim() : undefined;
  } catch {
    return undefined;
  }
}

function getOrCreateAiFallbackId(): string {
  const fallback = `tagit-ai-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;

  if (typeof window === 'undefined') {
    return fallback;
  }

  try {
    const existing = window.localStorage.getItem('tagitAiId')?.trim();
    if (existing) {
      return existing;
    }

    window.localStorage.setItem('tagitAiId', fallback);
    return fallback;
  } catch {
    return fallback;
  }
}

export function readTagItAnonymousIdentity(): TagItAnonymousIdentity {
  const localStorageEntityId = readLocalStorageTagItId();
  const cookieEntityId = readCookie('tagIt');
  const sessionId = readCookie('tagIt_sess');
  const hostname = typeof window !== 'undefined' ? window.location.hostname : undefined;

  if (localStorageEntityId) {
    return {
      userId: localStorageEntityId,
      entityId: localStorageEntityId,
      entityidType: 'ls',
      entityidAlgo: 'native',
      entityidOwner: hostname || 'tagit.live',
      sessionId,
    };
  }

  if (cookieEntityId) {
    return {
      userId: cookieEntityId,
      entityId: cookieEntityId,
      entityidType: 'ck',
      entityidAlgo: 'native',
      entityidOwner: hostname || 'tagit.live',
      sessionId,
    };
  }

  const fallbackEntityId = getOrCreateAiFallbackId();
  return {
    userId: fallbackEntityId,
    entityId: fallbackEntityId,
    entityidType: 'ls',
    entityidAlgo: 'native',
    entityidOwner: hostname || 'tagit.live',
    sessionId,
  };
}
